export * from '../useIndexQuery/useIndexQuery.types';
export { default as useReadIndexQuery } from './useReadIndexQuery';
